import { makeStyles } from '@mui/styles'

export default makeStyles((theme: any) => ({
    PatientFormDisclaimer: {
        borderLeft: `2px solid ${theme.palette.orangeWarning.main}`,
        display: 'flex',
        alignItems: 'stretch',
    },
    PatientFormDisclaimerLeft: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        padding: '0 1.6rem 0 .6rem',
    },
    PatientFormDisclaimerIcon: {
        width: '1.5rem',
        height: '1.5rem',
    },
    PatientFormDisclaimerRight: {},
    PatientFormDisclaimerTitle: {
        fontSize: '1.1rem',
        fontWeight: '800',
        color: theme.palette.orangeWarning.main,
        marginBottom: '.4rem',
    },
    PatientFormDisclaimerContents: {
        display: 'flex',
        flexDirection: 'column',
        gap: '.6rem',
    },
    PatientFormDisclaimerContent: {
        borderBottom: `1px solid ${theme.palette.lightGrey.half}`,
        '&:last-of-type': {
            borderBottom: 'none',
        },
        paddingBottom: '.6rem',
        '& a': {
            color: theme.palette.orangeWarning.main,
            textDecoration: 'underline',
            '&:hover': {
                textDecoration: 'none',
            },
        },
    },
}))
